<template>
  <div class="form-group">
    <div class="row form-group">
      <div class="col-12">
        <w-form-table>
          <thead>
            <tr>
              <th class="middle text-center" colspan="6">
                Wykaz otrzymanej pomocy de minimis&nbsp;(na dzień udzielonej pomocy)
              </th>
            </tr>

            <tr>
              <th class="middle " width="5%">Lp.</th>

              <th class="middle">Nazwa podmiotu udzielającego pomocy de minimis</th>

              <th class="middle" width="20%">Data udzielenia pomocy</th>

              <th class="middle" width="20%">Wartość pomocy w zł</th>

              <th class="middle" width="20%">Wartość pomocy w euro</th>

              <th width="8%" />
            </tr>
          </thead>

          <tbody>
            <minimis-row
              v-for="(item, index) in model.estimateDeMinimis.$items"
              :key="index + '.deMinimis'"
              :item="item.$item"
              :index="index"
            />

            <minimis-sum :model="model.estimateSum" />
          </tbody>

          <tfoot>
            <tr>
              <td colspan="6" class="text-right">
                <w-add-row :model="model.estimateDeMinimis" />
              </td>
            </tr>
          </tfoot>
        </w-form-table>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-6">
        <w-input :disabled="true" :model="model.totalCosts.plnAmount" />
      </div>

      <div class="col-6">
        <w-input :disabled="true" :model="model.totalCosts.inWordsPln" />
      </div>
    </div>

    <div class="row form-group">
      <div class="col-6">
        <w-input :disabled="true" :model="model.totalCosts.euroAmount" />
      </div>

      <div class="col-6">
        <w-input :disabled="true" :model="model.totalCosts.inWordsEuro" />
      </div>
    </div>
  </div>
</template>

<script>
import components from '@witkac/bootstrap4-components';

import MinimisRow from './MinStatementRow';
import MinimisSum from './MinStatementSum';
// @vuese
// @Got de Minimis
// @Group formStaticComponents
export default {
  components: {
    MinimisRow,
    MinimisSum,
    ...components
  },
  props: {
    // Przekazany schemat do wypełnienia
    model: { type: Object, required: true }
  }
};
</script>
